module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/sitebuilder/bravenet_sitebuilder_drag_and_drop_builder.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/sitebuilder/bravenet_sitebuilder_drag_and_drop_builder.png
// module id = 7UWA
// module chunks = 0